import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../../common/config";

export const cardPairsService = createApi({
  reducerPath: "cardPairs",
  baseQuery,
  endpoints: (builder) => ({
    getCardPairs: builder.query({
      query: (name) => ({
        url: `/api/users/getcardspairs/${name}`,
        method: "GET",
      }),
    }),
  }),
});
export const { useLazyGetCardPairsQuery } = cardPairsService;
